"use strict";

import angular from "angular";

import DialogConfirmation from "./dialog-confirmation.dialog.html";
import DialogCustom from "./dialog-custom.dialog.html";
import "./dialog-confirmation.dialog.scss";
import "./dialog-custom.dialog.scss";
import "./dialog.scss";

const serviceName = "DesnuDialogService";

export class DesnuDialogService {
    constructor($mdDialog, $templateCache) {
        this.$mdDialog = $mdDialog;
        this.$templateCache = $templateCache;
    }

    confirmation(options = {}) {
        const config = {
            controllerAs: "$ctrl",
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            template: DialogConfirmation,
            controller: "DialogCtrl",
            ...options
        };
        this._show(config);
    }

    custom(options = {}) {
        const config = {
            controllerAs: "$ctrl",
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            template: DialogCustom,
            controller: "DialogCtrl",
            ...options
        };
        this._show(this._normalizeCustomConfig(config));
    }

    _normalizeCustomConfig(config) {
        const hasCustomController =
            config.controller && config.controller !== "DialogCtrl";
        const templateHtml = config.locals?.templateHtml;
        if (!hasCustomController || !templateHtml) return config;
        const cacheKey =
            config.locals.templateCacheKey ||
            `desnu-dialog-content-${Date.now()}`;
        this.$templateCache.put(cacheKey, templateHtml);
        const { templateHtml: _removed, ...restLocals } = config.locals;
        return {
            ...config,
            locals: {
                ...restLocals,
                templateUrl: cacheKey
            }
        };
    }

    _show(config) {
        this.$mdDialog.show(config).then(
            (answer) => {
                if (config.after && config.after.hide)
                    config.after.hide(answer);
            },
            () => {
                if (config.after && config.after.cancel) config.after.cancel();
            }
        );
    }

    cancel() {
        this.$mdDialog.cancel();
    }

    hide() {
        this.$mdDialog.hide();
    }
}

DesnuDialogService.$inject = ["$mdDialog", "$templateCache"];
angular.module("nucont.shared").service("DesnuDialogService", DesnuDialogService);
angular.module("nucont.shared").service("DSNDialogService", DesnuDialogService);
export default { serviceName, DesnuDialogService };
